import { BlotterType } from 'models/blotters/BlotterType';
import type { Action } from 'state/actions';

import type { BlotterPanelState } from './blotterPanel.model';
import { initialBlotterPanelState } from './blotterPanel.model';

export function blotterPanelReducer(
  state: BlotterPanelState<BlotterType> = initialBlotterPanelState as BlotterPanelState<BlotterType>,
  action: Action,
): BlotterPanelState<BlotterType> {
  switch (action.type) {
    case 'BLOTTER_PANEL_ITEM_DETAILS_REQUESTED':
      return {
        ...state,
        id: action.id,
        item: action.item,
        blotterType: action.blotterType,
        actions: undefined,
        isFetching: true,
        isFetchingFailed: false,
        isShowFailedAlert: false,
        documents: undefined,
      };
    case 'BLOTTER_PANEL_ITEM_DETAILS_FETCHED':
      return {
        ...state,
        id: action.id,
        blotterType: action.blotterType,
        actions: action.details.actions,
        isFetching: false,
        isFetchingFailed: false,
        isShowFailedAlert: false,
        documents: action.details.documents,
      };

    case 'BLOTTER_PANEL_ITEM_DETAILS_FETCH_FAILED':
      return {
        ...state,
        id: action.id,
        blotterType: action.blotterType,
        actions: action.details.actions,
        isFetching: false,
        isFetchingFailed: action.details.isFetchingError ?? false,
        isShowFailedAlert: action.details.isFetchingError ?? false,
        documents: action.details.documents,
        fetchErrorDetails: action.error,
      };
    case 'BLOTTER_PANEL_ITEM_DETAILS_DISMISS_ALERT':
      return { ...state, isShowFailedAlert: false };
    case 'BLOTTER_PANEL_ITEM_RESET':
      return initialBlotterPanelState;
    case 'BLOTTER_PANEL_ITEM_SELECTED': {
      return {
        ...state,
        selected: {
          blotterType: action.blotterType,
          type: 'secondaryMarketTrades',
          id: action.id,
          quoteId: '',
        },
      };
    }
    case 'BLOTTER_PANEL_ITEM_SECONDARY_SELECTED':
      return {
        ...state,
        selected: {
          type: 'secondaryMarketTrades',
          quoteId: action.quoteId,
          blotterType: 'secondaryMarketTrades',
          id: action.quoteId,
        },
      };
    case 'BLOTTER_PANEL_PRICEIMPROVEMENT_ACTIONS_ADDED':
      return { ...state, actions: action.item?.details?.actions };

    case 'BLOTTER_PANEL_DOWNLOAD_STATUS_UPDATED':
      return {
        ...state,
        documents: state.documents
          ? {
              ...state.documents,
              docs: state.documents?.docs.map(doc =>
                doc.type === action.docType
                  ? {
                      ...doc,
                      items: doc.items?.map(item => {
                        if (item.language === action.language && item.format === action.format) {
                          return { ...item, status: action.status };
                        }
                        return item;
                      }),
                    }
                  : doc,
              ),
            }
          : undefined,
      };
    default:
      return state;
  }
}
